import { telephone } from "@simplybusiness/icons";
import {
  Button,
  DropdownMenu,
  Flex,
  Icon,
  Link,
  LinkButton,
} from "@simplybusiness/mobius";
import { useSnowplowContext } from "@simplybusiness/services";
import { PoweredBySb } from "./PoweredBySb";
import type { ContactDetailsProps } from "./types";
import { useLocale } from "../../hooks/useLocale";

export const ContactDetails = ({
  phoneNumber,
  poweredBySb,
  openingHours,
  supportUrl,
  openingHoursLabel,
}: ContactDetailsProps) => {
  const { snowplow } = useSnowplowContext();
  const { isUS } = useLocale();

  const handleHoursClick = () => snowplow?.trigger("operatingHoursClick");
  const handleMobileLinkClick = () => snowplow?.trigger("mobileLinkClick");

  return (
    <Flex alignItems="center">
      {poweredBySb && <PoweredBySb />}
      <Flex
        flexDirection="column"
        alignItems="end"
        className="mobius-header__contact --is-desktop"
      >
        <Flex gap="xs" alignItems="center">
          {phoneNumber && (
            <>
              <Icon
                className="mobius-header__phone-icon"
                icon={telephone}
                title="Call our support team"
              />
              <strong className="mobius-header__phone-number">
                {phoneNumber}
              </strong>
            </>
          )}
        </Flex>

        {supportUrl ? (
          <Link
            className="mobius-header__contact-link"
            href={supportUrl}
            variant="secondary"
            onClick={handleHoursClick}
          >
            {openingHoursLabel}
          </Link>
        ) : (
          <DropdownMenu
            trigger={
              <Button variant="link" onPress={handleHoursClick}>
                {openingHoursLabel}
              </Button>
            }
            className="mobius-header__dropdown"
          >
            {openingHours?.map(({ day, hours }) => (
              <DropdownMenu.Item key={day}>
                <span>
                  {day} {hours}
                </span>
              </DropdownMenu.Item>
            ))}
          </DropdownMenu>
        )}
      </Flex>

      <Flex
        alignItems="center"
        justifyContent="center"
        className="mobius-header__contact --is-mobile"
      >
        <LinkButton
          aria-label="Phone Us"
          href={`tel:${phoneNumber}`}
          size="sm"
          variant={isUS ? "secondary" : "primary"}
          onClick={handleMobileLinkClick}
        >
          <Icon icon={telephone} title="Call our support team" />
          Call us
        </LinkButton>
      </Flex>
    </Flex>
  );
};
